<template>
  <div
    class="appBar"
    :class="{immersive: immersive}"
  >
    <div class="fixed">
      <div
        class="statusBar"
      />
      <div
        class="titleBar"
      >
        <div
          v-if="showLeftIcon"
          class="leftIcon"
          @click="goBack"
        >
          <i class="hb-icon hb-icon-next" />
        </div>
        <div class="t">
          {{ showTitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadHbridge } from '@/utils/globalLoader';
import { goBack } from '@/utils';

export default {
  props: {
    title: {
      type: String,
      default: undefined,
    },
    immersive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      env: {},
    };
  },
  computed: {
    showLeftIcon() {
      const { env } = this;
      if (env.isAliMP || env.isAliMPMonitor) {
        // 小程序透明标题栏，已有返回键
        return false;
      }
      return true;
    },
    showTitle() {
      const { env } = this;
      if (env.isAliMP || env.isAliMPMonitor || this.immersive) {
        // 小程序透明标题栏，标题存在
        return '';
      }
      if (this.title === undefined) return this.$route.meta.title;
      return this.title;
    },
  },
  created() {
    loadHbridge().then(({ env }) => {
      this.env = env;
    });
  },
  methods: {
    goBack,
  },
};
</script>
<style lang="less" scoped>
.appBar {
  display: var(--app-bar-disable, none);
  height: var(--app-bar-height);

  .fixed {
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 100;

    .statusBar {
      height: var(--status-bar-height);
    }

    .titleBar {
      height: var(--title-bar-height);
      display: flex;
      align-items: center;
      color: #242729;

      .t {
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        flex: 1;
        padding-right: 40px;
      }

      .leftIcon {
        display: flex;
        align-items: center;
        padding-left: 12px;
        height: 100%;

        .hb-icon {
          font-size: 30px;
          transform: rotate(180deg);
          font-weight: 500;
        }
      }
    }
  }

  &.immersive {
    height: 0;

    .fixed {
      background: transparent;
      width: 0;

      .leftIcon {
        position: fixed;
        width: 32px;
        height: 32px;
        background: rgba(36, 39, 41, 0.2);
        border-radius: 10px;
        color: #fff;
        left: 12px;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
